module.exports = __webpack_public_path__ + "b570fae9fc5442ddc21b71d64736939b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/piano/2_C#2.mp3
// module id = 99
// module chunks = 0